import { useQuery } from '@tanstack/react-query';

import { benefitsQuery } from '@phoenix/team-m/my-tool-shed/frontend/domain/service/benefits-api.graphql';
import { Raffle, Voucher } from '@phoenix/team-m/my-tool-shed/frontend/domain/model/benefits.model';

import { useGraphqlFetcher } from '../use-graphql-fetcher';

export interface BenefitsQueryResponse {
  errors?: any;
  data: {
    benefits: {
      raffles: Raffle[];
      vouchers: Voucher[];
    };
  };
}

export const useBenefitsQuery = () => {
  const queryFetcher = useGraphqlFetcher<BenefitsQueryResponse>(benefitsQuery, process.env.NEXT_PUBLIC_MARKETING_GRAPHQL_ENDPOINT);

  return useQuery({
    queryKey: ['benefits'],
    queryFn: () => queryFetcher(),
    select: (result) => result.data.benefits,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
